"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as m, forwardRef as s } from "react";
import { useSvgIcon as c } from "../useSvgIcon.js";
const i = m(
  s((r, n) => {
    const { monochrome: p, ...e } = r, t = c({
      ...e,
      ref: n
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: /* @__PURE__ */ o(
          "path",
          {
            d: "M20.2869 6.5151H18.1811C14.3203 6.5151 12.2897 8.393 12.2897 11.1618C12.2897 14.2917 13.6936 15.7581 16.5766 17.6383L18.9582 19.1791L12.1142 29H7L13.1421 20.2144C9.6095 17.7827 7.6267 15.4211 7.6267 11.4266C7.6267 6.4188 11.2618 3 18.156 3H25V28.9759H20.2869V6.5151Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
i.displayName = "IconYandex";
export {
  i as IconYandex
};
